module.exports = __webpack_public_path__ + "media/src/images/photos/typing-6020743e9c4dc88c6f4397816bc4aca9.jpg";